module.exports = __webpack_public_path__ + "static/kongsir-c4c97d09cd379b19a4918730cc78028f.jpg";